import dayjs from "dayjs";
import type {BopisStorageType} from "../types/bopis";

/**
 * Returns if the session expiration has been over 30 minutes
 * @memberof BopisLocation
 * @param location {Object} - Location object that is destructured
 * into just the expiration key/value
 * @return   {Boolean} - Boolean if the expiration has expired or not
 */
export default function hasLocationExpired({
  expiration,
}: Partial<BopisStorageType>): boolean {
  if (expiration) {
    return dayjs(expiration).add(30, "minutes").isBefore(dayjs());
  }

  return true;
}
